import React from 'react';
import { Tag, TagText, Container } from './styles';

import ClubeIcon from '../../images/icons/clube.svg';

export function TagClube() {
  return (
    <Container>
      <Tag>
        <img src={ClubeIcon} alt={'clube icon'} />
        <TagText>Acesso exclusivo antecipado!</TagText>
      </Tag>
    </Container>
  );
}
